// 행사 연도 단일 진실 공급원(SSOT)
// - basename, dev 진입 경로 정규식, main_list 조회용 year 등에 모두 사용
export const EVENT_YEAR = 2026;
export const BASENAME = `/${EVENT_YEAR}`;
export const DEV_ENTRY_PATH_REGEX = new RegExp(`^/${EVENT_YEAR}/?$`);
